import { Parameters } from '../Schema/Parameters';
import { createStore } from 'satcheljs';

const initialStore: Parameters = {
    mailboxInfo: null,
    scenarioName: '',
};

export const getParameterStore = createStore<Parameters>('FilesViewParameterStore', initialStore);
